import shingles from '../../Builder/Data/Providers/helpers/ShingleList';
import List from '../../Roofing/Shingles/List';

import '../../../../assets/stylesheets/pages/pys-filter.scss';
import '../../../../assets/stylesheets/pages/pys-favorites.scss';

import { connectLocation } from '../../location/LocationConnectors';

const ShinglesList = connectLocation(props => {
  return (
    <List
      shingles={shingles(props)}
      featureFlags={[]}
      {...props}
    />
  );
});

export default ShinglesList;
